import React from 'react';
import { getDocumentRuntime, O17, O19 } from '../../../backend/runtime';
import { LegacyPackageDetail } from './LegacyPackageDetail';
import { PackageLotsDetail } from './PackageLotsDetail';

export const PackageDetail = () => {
  const { profile } = getDocumentRuntime();
  if (profile.id === O17) return <LegacyPackageDetail />;
  if (profile.id === O19) return <PackageLotsDetail />;
  return <p role="alert">Packages are unavailable for this backend.</p>;
};
